<template>
    <form @submit.prevent="submitForm">
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Associate users</p>
            </header>
            <section class="modal-card-body">
                <b-notification type="is-danger" v-if="errorMessage" :closable="false">
                    {{ errorMessage }}
                </b-notification>

                 <b-table
                v-if="availableUsers.length > 0"
                :data="availableUsers"
                :columns="[{ field: 'userEmail', label: 'User' }, {field: 'isActive', label: 'User Status'}]"
                :checked-rows.sync="selectedUsers"
                checkable>
            </b-table>
                <div class="has-text-grey" v-else>
                    <p>No users available</p>
                </div>

            </section>
            <footer class="modal-card-foot">
                <button type="button" class="button" @click="onCancelAction">Cancel</button>
                <button type="submit" class="button is-primary" v-if="availableUsers.length > 0"
                    :disabled="selectedUsers.length == 0">Associate users</button>
            </footer>
        </div>
    </form>
</template>

<script>
import _ from 'lodash';

import netbaseService from '@/services/netbase-service.js';

export default {
    name: 'TokenUserAssocationForm',
    props: {
        token: Object
    },
    data() {
        return {
            errorMessage: '',
            availableUsers: [],
            selectedUsers: [],
            isLoading: true
        };
    },
    async created() {
        try {
            let availableUsers = await netbaseService.getAllUsersWithoutAccessToken();

            if (availableUsers && availableUsers.data.length > 0) {
                this.availableUsers = _(availableUsers.data)
                    .sortBy('userEmail')
                    .value();
            }
            
            this.availableUsers.forEach(element => {
                element.isActive = element.isActive ? "Active" : "Inactive";
            });
        } catch (error) {
            this.errorMessage = error.message;
        } finally {
            this.isLoading = false;
        }
    },
    methods: {
        async submitForm() {
            try {
                await netbaseService.associateUsersWithAccessToken(this.token.id, this.selectedUsers.map(user => user.userId));

                this.$emit('submitEvent', this.selectedUsers);
                this.$parent.close();
            } catch (error) {
                if (error.response && error.response.data) {
                    this.errorMessage = error.response.data;
                } else {
                    this.errorMessage = error.message;
                }
            }
        },
        onCancelAction() {
            this.$parent.close();
        }
    }
};

</script>

<style lang="scss" scoped>
.modal-card-foot {
    justify-content: flex-end;
}
</style>
